import React from "react";

import "./ContactCard.css"

const ContactCard = (props) => {
    const { title, mail, phone1, phone2 } = props;
  
    return (
    
              <div className="contact-card">
                <h4>{title}</h4> 
                <div>
                   <a href={`mailto:${mail}`}>{mail}</a>      
                </div>
                <div>
                    {phone1}
                </div>  
                <div>
                    {phone2}
                </div>
              </div>
          
    );
  };

  export default ContactCard;